module.exports = "/_next/static/images/f26870fb41f4fcdd84f3d76c5ee2126e-cajitas-right-desktop.jpg";